import { Container } from "react-grid-system";
import Breadcrumbs from "@components/Breadcrumbs";
import LinkedInButton from "@components/blog/buttons/LinkedInButton";
import CopyButton from "@components/blog/buttons/CopyButton";
import EmailButton from "@components/blog/buttons/EmailButton";
import Tags from "@components/Tags";
import theme from "@config/theme";
import { formatPublishDate, stringToURI } from "@scripts/utils";
import Webinar from "./Webinar";

const WebinarsPage = ({ webinar }: { webinar: Webinar }) => (
  <>
    <Container>
      <div className="blog-post-page">
        <Breadcrumbs
          links={[
            { name: "Webinars", url: "/webinars" },
            {
              name: webinar.title,
              url: `/blog/${stringToURI(webinar.title)}`,
            },
          ]}
        />

        <h1 className="blog-post-title">{webinar.title}</h1>

        <div className="blog-post-heading">
          <div className="blog-post-hero">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${webinar.youtubeId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>

          <div>
            <p className="blog-post-date">{formatPublishDate(webinar.date)}</p>
            <h2 className="blog-post-excerpt">{webinar.shortDescription}</h2>
            <div className="blog-post-tags">
              <Tags
                tags={webinar.tags.map((tag) => ({
                  name: tag,
                }))}
              />
            </div>

            <div className="blog-share-buttons">
              <LinkedInButton />
              <CopyButton />
              <EmailButton />
            </div>
          </div>
        </div>
      </div>
    </Container>

    <style jsx>{`
      .blog-post-page {
        padding: 0 1rem;
        max-width: 1140px;
        margin: 0 auto;
      }
      .blog-post-heading {
        display: flex;
      }

      .blog-post-hero {
        width: 1000px;
      }

      .blog-post-hero iframe {
        border-radius: 4px;
        box-shadow: ${theme.misc.boxShadowBlogImage};
        margin-right: 2rem;
      }

      .blog-post-date {
        color: ${theme.colors.gray3};
        margin: 0;
      }

      .blog-post-excerpt {
        font-weight: 400;
        margin-top: 1rem;
        margin-bottom: 2rem;
        font-size: ${theme.fonts.size.px26};
      }

      .blog-share-buttons {
        margin-top: 1.5rem;
        display: flex;
        gap: 0.5rem;
      }

      @media screen and (max-width: ${theme.breakpoints.md}px) {
        .blog-post-heading {
          display: block;
        }
        .blog-post-date {
          margin-top: 1rem;
        }
        .blog-post-excerpt {
          margin-bottom: 1rem;
        }
      }
      @media screen and (max-width: ${theme.breakpoints.sm}px) {
        iframe {
          width: 350px;
          height: 200px;
        }
      }
    `}</style>
  </>
);

export default WebinarsPage;
